import { render, staticRenderFns } from "./PublicRecipeView.vue?vue&type=template&id=652bee48&scoped=true"
import script from "./PublicRecipeView.vue?vue&type=script&lang=js"
export * from "./PublicRecipeView.vue?vue&type=script&lang=js"
import style0 from "./PublicRecipeView.vue?vue&type=style&index=0&id=652bee48&prod&scoped=true&lang=css"
import style1 from "./PublicRecipeView.vue?vue&type=style&index=1&id=652bee48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652bee48",
  null
  
)

export default component.exports